import { ProductRepository } from '../repositories/ProductRepository';
import { diContainer, serviceNames } from '../../service-setup/diContainer';

export class ProductFullLoadedUseCase {
    private productRepository: ProductRepository;
    private productId: string;
    private skuId: string;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(productId: string, skuId: string) {
        this.productRepository = diContainer.get(serviceNames.productRepository);
        this.productId = productId;
        this.skuId = skuId;
    }

    public execute = () => {
        this.productRepository.updateProductId(this.productId);
        this.productRepository.setSelectedSkuId(this.skuId);
    };
}
